import './scss/FilterSummary.scss';
import {useIntl} from "react-intl";
import { getFilterLabel, formatDateRange } from './filterUtils';

const FilterSummary = ({ dateRange, useCases, campaigns, surveys, locations, degrees, groups, onClearFilters, surveyConfig, useCaseData = [], customerSegment = "" }) => {
    const intl = useIntl();

    const hasActiveFilters = dateRange?.length > 0 ||
        useCases?.length > 0 ||
        campaigns?.length > 0 ||
        surveys?.length > 0 ||
        locations?.length > 0 ||
        degrees?.length > 0 ||
        groups?.length > 0;

    if (!hasActiveFilters) return null;

    const createFilterString = () => {
        const parts = [];

        const formattedDate = formatDateRange(dateRange, intl);
        if (formattedDate) parts.push(formattedDate);

        const filterOrder = [
            { values: useCases, type: 'useCases' },
            { values: campaigns, type: 'campaigns' },
            { values: surveys, type: 'surveys' },
            { values: locations, type: 'locations' },
            { values: degrees, type: 'degrees' },
            { values: groups, type: 'groups'}
        ];

        const utils = { surveyConfig, useCaseData, customerSegment, intl };

        filterOrder.forEach(({ values, type }) => {
            if (values?.length > 0) {
                const labels = values.map(value => getFilterLabel(value, type, utils));
                parts.push(labels.join(', '));
            }
        });

        return parts.join(', ');
    };

    const getTitleDescription = () => {
        if (useCases?.length > 0) {
            const descriptions = useCases.map(id =>
                intl.formatMessage({
                id: `usecase.${id}.description`,
                defaultMessage: useCaseData?.[id]?.description || useCaseData?.[id]?.title || id || ''
            }))
            return descriptions.join(' ')
        }
        return ''
    }

    return (
        <div className="filter-header">
            <div>
                <h2 title={getTitleDescription() || createFilterString()}>
                    {createFilterString()}
                </h2>
                <button
                    className="clear-filters"
                    onClick={onClearFilters}
                >
                    {intl.formatMessage({
                        defaultMessage: 'Clear filters',
                        id: 'clearFilters'
                    })}
                </button>
            </div>
        </div>
    );
}

export default FilterSummary;
